import React, { useState } from 'react';
import { validatePassword, PASSWORD_REQUIREMENTS } from '../../utils/passwordValidation';

/**
 * Reusable password input component with built-in validation
 * Matches backend validation requirements (12+ chars, uppercase, lowercase, number, special char)
 */
const PasswordInput = ({
  value,
  onChange,
  required = false,
  label = 'Password',
  placeholder = 'Enter secure password',
  showRequirements = true,
  showStrength = false,
  disabled = false,
  className = '',
  autoComplete = 'new-password'
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const validation = validatePassword(value);
  const showValidation = value && value.length > 0;

  return (
    <div className={className}>
      {label && (
        <label className="form-label small mb-1">
          {label} {required && <span className="text-danger">*</span>}
        </label>
      )}

      <div className="input-group input-group-sm">
        <input
          type={showPassword ? 'text' : 'password'}
          className={`form-control form-control-sm ${showValidation && !validation.isValid ? 'is-invalid' : ''} ${showValidation && validation.isValid ? 'is-valid' : ''}`}
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          required={required}
          placeholder={placeholder}
          disabled={disabled}
          autoComplete={autoComplete}
          minLength={12}
        />
        <button
          className="btn btn-outline-secondary"
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          disabled={disabled}
          tabIndex={-1}
        >
          <i className={`fas fa-eye${showPassword ? '-slash' : ''}`}></i>
        </button>
      </div>

      {/* Validation feedback */}
      {showValidation && !validation.isValid && (
        <div className="invalid-feedback d-block">
          {validation.error}
        </div>
      )}

      {/* Requirements hint */}
      {showRequirements && (isFocused || (showValidation && !validation.isValid)) && (
        <small className="text-muted d-block mt-1">
          <strong>Password requirements:</strong>
          <ul className="mb-0 ps-3">
            {PASSWORD_REQUIREMENTS.map((req, idx) => (
              <li key={idx}>{req}</li>
            ))}
          </ul>
        </small>
      )}

      {/* Success feedback */}
      {showValidation && validation.isValid && (
        <div className="valid-feedback d-block">
          <i className="fas fa-check-circle me-1"></i>
          Password meets requirements
        </div>
      )}
    </div>
  );
};

export default PasswordInput;
